// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2EftO","consentsList":"PatientConsents_consentsList__2EBlN","consentsListEmpty":"PatientConsents_consentsListEmpty__2fv4G"};